import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 font-medium text-xl mb-3" }, "Create A New Campaign", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3" }, "Odio euismod lacinia at quis risus sed vulputate odio. Non nisi est sit amet. Egestas integer eget aliquet nibh praesent tristique magna.", -1)
const _hoisted_3 = { class: "surface-card p-4 shadow-2 border-round" }
const _hoisted_4 = { class: "grid formgrid p-fluid" }
const _hoisted_5 = { class: "field mb-4 col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "font-medium"
}, "Name", -1)
const _hoisted_7 = { class: "field mb-4 col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "font-medium"
}, "Description", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "surface-100 mb-3 col-12",
  style: {"height":"2px"}
}, null, -1)
const _hoisted_10 = { class: "field mb-4 col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "font-medium"
}, "Phone Number", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 pt-3 text-600 line-height-3 mr-3" }, "In order to send messages via your campaign, you will need to associate it with a phone number. If you have not yet purchased a phone number, that's okay! You can always come back and add it.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "surface-100 mb-3 col-12",
  style: {"height":"2px"}
}, null, -1)
const _hoisted_14 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.createLoading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"85vh"} }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputText, {
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                id: "name",
                type: "text"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Textarea, {
                modelValue: _ctx.description,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
                id: "description",
                type: "text"
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.selectedPhoneNumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPhoneNumber) = $event)),
                options: _ctx.phoneNumberOptions,
                optionLabel: "name",
                optionDisabled: "disabled",
                filter: true,
                filterBy: "name",
                showClear: true
              }, null, 8, ["modelValue", "options"]),
              _hoisted_12
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.routeNames.campaigns }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: "Cancel",
                    severity: "secondary",
                    outlined: "",
                    class: "w-auto mt-3 mr-3"
                  })
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_Button, {
                onClick: _ctx.createCampaign,
                label: "Create Campaign",
                class: "w-auto mt-3"
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}